import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/t_logo.png'


const _hoisted_1 = {
  key: 0,
  class: "mt-2 d-flex flex-fill justify-content-center flex-column"
}
const _hoisted_2 = { class: "text-center fs-1 fw-bold mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-primary mt-5 d-flex align-self-center flex-column fs-4"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "text-danger mt-5 d-flex align-self-center fs-4"
}
const _hoisted_6 = {
  key: 2,
  class: "text-danger mt-5 d-flex align-self-center fs-4"
}
const _hoisted_7 = {
  key: 3,
  class: "mb-3 d-flex align-self-center fs-4"
}
const _hoisted_8 = { class: "mt-2 d-flex flex-fill justify-content-center" }
const _hoisted_9 = {
  class: "container",
  style: {"max-width":"800px"}
}
const _hoisted_10 = {
  key: 0,
  class: "card card-body bg-light align-self-center p-5 mb-0"
}
const _hoisted_11 = { class: "row mb-sm-2" }
const _hoisted_12 = { class: "col-sm-8" }
const _hoisted_13 = { class: "row mb-sm-2" }
const _hoisted_14 = { class: "col-sm-8" }
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = ["type"]
const _hoisted_17 = {
  class: "fs-6 position-absolute w-100 text-primary",
  style: {"left":"0px","top":"-8px"}
}
const _hoisted_18 = { class: "badge bg-primary" }
const _hoisted_19 = { class: "row mb-sm-2" }
const _hoisted_20 = { class: "col-sm-8" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = ["type"]
const _hoisted_23 = {
  class: "fs-6 position-absolute w-100 text-primary",
  style: {"left":"0px","top":"-8px"}
}
const _hoisted_24 = { class: "badge bg-primary" }
const _hoisted_25 = {
  key: 1,
  class: "ps-5 pe-5"
}
const _hoisted_26 = { class: "row mt-3" }
const _hoisted_27 = { class: "col-sm-8 offset-sm-4" }
const _hoisted_28 = { class: "d-flex" }
const _hoisted_29 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_ctx.ready)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "img-fluid"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
        (_ctx.reseted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[7] || (_cache[7] = _createTextVNode(" パスワードを再設定しました。 ", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
              _cache[9] || (_cache[9] = _createTextVNode(" 下記よりログインしてください。", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
              _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("a", { href: _ctx.loginPath }, "日本歯科衛生協会 Webユーザーサイトログイン", 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loginId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 不正なURLであるため処理できません。 "))
          : _createCommentVNode("", true),
        (_ctx.timeout)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 有効期限切れのURLであるため処理できません。 "))
          : _createCommentVNode("", true),
        (!_ctx.alreadyResetd && _ctx.loginId && !_ctx.reseted && !_ctx.timeout)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[12] || (_cache[12] = [
              _createTextVNode(" パスワードの再設定を行います。", -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" 新しいパスワードを入力してください。 ", -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (!_ctx.alreadyResetd && _ctx.loginId && !_ctx.reseted && !_ctx.timeout)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, "ログインID（メールアドレス）", -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginId) = $event)),
                        class: "form-control bg-light form-control-lg",
                        readonly: "true"
                      }, null, 512), [
                        [_vModelText, _ctx.loginId]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, [
                      _createElementVNode("span", { class: "badge bg-danger me-2" }, "必須"),
                      _createTextVNode("パスワード")
                    ], -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.showPassword ? 'type' :'password',
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                          class: "form-control form-control-lg",
                          style: _normalizeStyle({'background-color': !_ctx.password ? '' : (_ctx.validPassword ? 'aquamarine' : 'lightpink')}),
                          maxlength: "32"
                        }, null, 12, _hoisted_16), [
                          [_vModelDynamic, _ctx.password]
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-lg border-start-0 bg-white",
                          style: {"border-color":"lightgray"},
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.showPassword ? '非表示' : '表示'), 1)
                          ]),
                          _createVNode(_component_fa, {
                            class: "me-1 text-primary",
                            icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                          }, null, 8, ["icon"])
                        ])
                      ])
                    ])
                  ]),
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "row mb-sm-2" }, [
                    _createElementVNode("div", { class: "col-sm-8 offset-sm-4" }, [
                      _createTextVNode(" 8～32文字で入力してください。"),
                      _createElementVNode("br"),
                      _createTextVNode(" 英文字(大文字、小文字)、数字、記号の2種類以上で作成してください。"),
                      _createElementVNode("br"),
                      _createTextVNode(" ※使用可能な記号  ! # $ % & / = ? @ ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, [
                      _createElementVNode("span", { class: "badge bg-danger me-2" }, "必須"),
                      _createTextVNode("パスワード（確認用）")
                    ], -1)),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _withDirectives(_createElementVNode("input", {
                          onPaste: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                          type: _ctx.showPassword ? 'type' :'password',
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                          class: "form-control form-control-lg",
                          style: _normalizeStyle({'background-color': !_ctx.confirmPassword ? '' : ((_ctx.password===_ctx.confirmPassword) ? 'aquamarine' : 'lightpink')}),
                          maxlength: "32"
                        }, null, 44, _hoisted_22), [
                          [_vModelDynamic, _ctx.confirmPassword]
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-lg border-start-0 bg-white",
                          style: {"border-color":"lightgray"},
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
                        }, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.showPassword ? '非表示' : '表示'), 1)
                          ]),
                          _createVNode(_component_fa, {
                            class: "me-1 text-primary",
                            icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                          }, null, 8, ["icon"])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.alreadyResetd && _ctx.loginId && !_ctx.reseted && !_ctx.timeout)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("button", {
                          ref: "resetPasswordButton",
                          class: "btn btn-lg btn-primary text-white flex-fill",
                          disabled: !_ctx.canReset,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetPassword()))
                        }, [
                          _createVNode(_component_fa, {
                            class: "me-1",
                            icon: "rotate-right"
                          }),
                          _cache[17] || (_cache[17] = _createTextVNode("再設定する", -1))
                        ], 8, _hoisted_29)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}